
import { Button, Typography, Dialog, DialogContent, DialogActions, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StockCountCreateContext, StockCountCreateValues } from '../../contexts/StockCountCreateContext';
import { useContext } from 'react';
import { CloseDialogAction } from '../../../../components/shared/dialogs/CloseDialogAction';

const StockCountCreateDeleteCategoryModal = () => {
  const { isCategoryDeleteModalOpen,
    handleClose,
    deleteCategories,
    categoryData,
    categoryId } = useContext(StockCountCreateContext) as StockCountCreateValues;

  const { t } = useTranslation('createStockCount');

  const handleConfirm = () => {
    if (categoryId !== undefined) {
      const data = categoryData?.filter(item => item.id !== categoryId);
      deleteCategories(data);
    }
    else {
      deleteCategories([]);
    }
  };

  return (
    <Dialog open={isCategoryDeleteModalOpen}
      onClose={handleClose}
      maxWidth='sm'
      fullWidth>
      <DialogTitle>
        {t('deleteCategory')}
        <CloseDialogAction onCancel={handleClose} />
      </DialogTitle>
      <DialogContent>
        <Typography>{t('approvalDialogMessage')}</Typography>
      </DialogContent>
      <DialogActions >
        <Button
          variant="secondary"
          size='lg'
          onClick={handleClose}> {t('cancel')}</Button>
        <Button variant="bad"
          size='lg'
          onClick={handleConfirm}>
          {t('confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StockCountCreateDeleteCategoryModal;